import { useMutation } from "@apollo/client";

import { GqlClient, GqlProjectCreateInput } from "~/__generated__";

import { ProjectListScreen_GetAllDocument } from "../../ProjectListScreen/queries.generated";
import { ProjectCreateDocument } from "../mutations.generated";

export default function useProjectCreate(client: GqlClient) {
    const [projectCreate, { data, loading, error }] = useMutation(ProjectCreateDocument, {
        refetchQueries: [ProjectListScreen_GetAllDocument],
    });

    return {
        projectCreate: (projectdata: Omit<GqlProjectCreateInput, "clientId">) =>
            projectCreate({
                variables: { input: { ...projectdata, clientId: client.id } },
            }),
        loading,
        error,
        data: data?.projectCreate,
    };
}
